import { TFunction } from 'next-i18next';
import { TFullImageWithHeading } from '@features/cms/typescript';
import { BASE_PATH } from '@config/index';
const getFullImageWithHeadingData = (t: TFunction): TFullImageWithHeading => ({
  backgroundImage: {
    desktop: `${BASE_PATH}/img/voxbox_vr_bg.png`,
    tablet: `${BASE_PATH}/img/voxbox_vr_bg.png`,
    mobile: `${BASE_PATH}/img/voxbox_vr_bg_mobile.png`
  },
  description: t('voxboxInfo.description'),
  buttonText: t('voxboxInfo.button'),
  buttonUrl: '/pages/voxbox#livechat-voxbox',
  thumbnail: '',
  title: t('voxboxInfo.title'),
  subtitle: t('voxboxInfo.subtitle'),
  video: null,
  variant: 'other',
  variantContent: 'start',
  contentWidth: 'small'
});
export default getFullImageWithHeadingData;